import pengaturansoal from '../../../views/Kurikulum/Elearning/pengaturansoal.view';

export default pengaturansoal;